import React, {useEffect} from 'react';
import "./Contact.scss";

declare global {
    interface Window {
        hbspt: any;
    }
}

function Contact() {
    useEffect(() => {
        (function loadHubSpot() {
            window.hbspt.forms.create({ 
                region: "na1",
                portalId: "5152848",
                formId: "1247612b-27c2-424f-82ae-a15fdff5a08b",
                target: '.contact-wrapper'
            });
        })();
    }, []);

    return (
        <><div className="contacts-block">
            <p className={'contact-us-form'}>Contact us:</p>
            <div className="contact-wrapper animate__animated animate__zoomInDown"></div>
            </div>
        </>
    );
}

export default Contact;
